import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EmailJobTrigger } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<EmailJobTrigger & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Id', row => row.jobTriggerId),
		buildColumn(util, 'Text', row => row.name, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.audienceName, { header: 'Audience' }),
		buildColumn(util, 'Text', row => row.function, { header: 'Function', group: 'asc', hidden: true }),
		buildColumn(util, 'Text', row => row.days, { header: 'Schedule' }),
		buildColumn(util, 'YesNo', row => !!row.stopSetName, { header: 'Can Opt-out' }),
		buildColumn(util, 'Text', row => row.stopSetName, { header: 'Stop Set', hidden: true }),
		buildColumn(util, 'Text', row => row.description, { header: 'Description', width: 300 }),
	];


	return columns;

}